import { useState } from 'react';
import config from 'config';
import SalesContactDialog from 'components/SalesContactDialog';

const useSalesContact = ({ user, source }) => {
  const [contact, setContact] = useState(null);
  const meetingBookingEnabled = config.meetingBookingEnabled === true;

  const handleSalesContact = async (contactUser = user) => {
    // The embed and its remote script are only loaded for an enabled booking request.
    if (meetingBookingEnabled) {
      try {
        const { getCalApi } = await import('@calcom/embed-react');
        const cal = await getCalApi({ namespace: 'enterprise-demo' });
        cal('ui', {
          cssVarsPerTheme: { light: { 'cal-brand': '#8f3ff9' }, dark: { 'cal-brand': '#8f3ff9' } },
          hideEventTypeDetails: false,
          layout: 'month_view'
        });
        cal('modal', {
          calLink: 'vlad-rimo-4hr6iy/15min',
          config: { name: contactUser?.name || '', email: contactUser?.email || '', layout: 'month_view' }
        });
        return;
      } catch (error) {
        setContact({ user: contactUser, bookingError: true });
        return;
      }
    }
    setContact({ user: contactUser });
  };

  return {
    meetingBookingEnabled,
    handleSalesContact,
    salesContactDialog: contact ? (
      <SalesContactDialog user={contact.user} source={source} bookingError={contact.bookingError} onClose={() => setContact(null)} />
    ) : null
  };
};

export default useSalesContact;
